<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1806.68 1960.6">
  <defs>
    <style>
      .cls-1 {
        fill: #24abe2;
      }

      .cls-2 {
        fill: #f26924;
      }
    </style>
  </defs>
  <g>
    <rect class="cls-2" x="831.63" y="106.95" width="975.05" height="1772.92"/>
    <path class="cls-1" d="M831.63,356.63c25.23-3.85,44.85-4.29,52.32-4.29,1.64,0,2.54.02,2.65.02,192.69,0,353.04,88.44,431.91,164.16,147.65,141.75,218.15,310.47,209.57,501.48-5.6,124.55-43.29,219.74-73.92,277.62-14.62,27.65-29.08,49.69-40.71,65.73.79-145.68-71.56-278.45-202.8-369.05-128.37-88.64-249-90.29-313.82-91.2l-4.25-.06c-21.95-.32-43.32-2.82-60.94-5.83v188.8c19.8,1.27,37.31,1.51,51.95,1.71l4.25.06c58.36.86,109.58,17.16,110.1,17.33,116.32,40.91,189.98,121.63,201.77,221.33,12.32,104.42-18.51,175.83-106.4,246.55-75.16,60.44-177.18,63.51-196.87,63.51-1.63,0-2.53-.03-2.63-.03-21.11,0-41.88-1.06-62.16-3.06v184.47c19.36,1.36,38.88,2.04,58.58,2.04,455.34,0,824.48-369.14,824.48-824.48S1345.55,168.89,890.2,168.89c-19.69,0-39.22.69-58.58,2.05v185.68Z"/>
  </g>
  <g>
    <polygon class="cls-2" points="768.48 0 768.48 1960.6 0 1877.95 0 99.45 768.48 0"/>
    <path class="cls-1" d="M768.48,279.82c-37.79,11.15-87.83,33-129,75.49-81.93,83.15-110.66,161.83-99.17,272.9,10.97,106.37,79.64,190.79,188.08,232.2.27.1,16.23,5.68,40.09,10.34v208.82c-62.72-5.39-148.65-24.2-238.37-95.34-122.33-94.08-189.77-231.2-189.04-383.48-10.84,17.39-24.31,41.14-37.95,70.64-28.55,61.5-63.68,161.23-68.9,289.8-8.01,196.84,57.71,372.72,195.34,527,64.57,74.24,188.2,164.45,338.92,194.18v203.6C372.25,1814.17,60.3,1425.62,60.3,988.61S372.79,156.39,768.48,74.65v205.17Z"/>
  </g>
</svg>